const signup = (editor) => {

    editor.BlockManager.add('signup', {
        category: 'Login & Register',
        label: `
        <svg  width="1.6vw" height="1.6vw" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
          <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z"/>
        </svg>  
        <div class='gjs-fontFamily gjs-block-label'>Sign Up</div>
                  `,
        attributes: {},
        content: `
        <div class="row d-flex my-4 mx-auto justify-content-center align-items-center ">
          <div class="col-lg-12 col-xl-11">
            <div class="card text-black rounded-lg shadow" >
              <div class="card-body p-md-5">
                <div class="row justify-content-center">
                  <div class="col-md-10 col-lg-6 col-xl-5 order-2 order-lg-1">

                    <p class="text-center h1 fw-bold mb-5 mx-1 mx-md-4 mt-4">Sign up</p>

                    <form class="mx-1 mx-md-4">

                      <div class="d-flex flex-row align-items-center mb-4">
                        <i class="bi-person me-3"></i>
                        <div class="form-outline flex-fill mb-0">
                          <input type="text" id="form3Example1c" placeholder="Name" class="form-control" />
                          <label class="form-label d-none" for="form3Example1c">Your Name</label>
                        </div>
                      </div>

                      <div class="d-flex flex-row align-items-center mb-4">
                        <i class="bi-envelope me-3"></i>
                        <div class="form-outline flex-fill mb-0">
                          <input type="email" id="form3Example3c" placeholder="Email" class="form-control" />
                          <label class="form-label d-none" for="form3Example3c">Your Email</label>
                        </div>
                      </div>

                      <div class="d-flex flex-row align-items-center mb-4">
                        <i class="bi-lock me-3"></i>
                        <div class="form-outline flex-fill mb-0">
                          <input type="password" id="form3Example4c" placeholder="Password" class="form-control" />
                          <label class="form-label d-none" for="form3Example4c">Password</label>
                        </div>
                      </div>

                      <div class="d-flex flex-row align-items-center mb-4">
                        <i class="bi-key me-3"></i>
                        <div class="form-outline flex-fill mb-0">
                          <input type="password" id="form3Example4cd" placeholder="Repeat Password" class="form-control" />
                          <label class="form-label d-none" for="form3Example4cd">Repeat your password</label>
                        </div>
                      </div>

                      <div class="form-check d-flex  mb-5">
                        <input class="form-check-input me-2" type="checkbox" value="" id="form2Example3c" />
                        <label class="form-check-label" for="form2Example3">
                          I agree all statements in <a href="#!">Terms of service</a>
                        </label>
                      </div>

                      <div class="d-flex justify-content-center mx-4 mb-3 mb-lg-4">
                        <button type="button" class="btn btn-primary btn-lg">Register</button>
                      </div>

                    </form>

                  </div>
                  <div class="col-md-10 col-lg-6 col-xl-7 d-flex align-items-center order-1 order-lg-2">

                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/draw1.webp"
                      class="img-fluid" alt="Sample image">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        `
    })
};

export default signup;